import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Formatação de dinheiro: implementação única em @mustauto/utils, com a
// unidade no nome (formatReais = numeric(12,2); formatCentavos = inteiro em
// centavos, como items[].unitPrice da OS).
export { formatReais, formatCentavos } from '@mustauto/utils';

export function formatNumber(value: number): string {
  return new Intl.NumberFormat('pt-BR').format(value);
}
